import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect } from 'react-router-dom';
import Home from '~pages/home';
import TermsOfService from '~pages/legal/terms-of-service';
import PrivacyPolicy from '~pages/legal/privacy-policy';
import ProofOfValueAgreement from '~pages/legal/proof-of-value-agreement';
import ServiceAgreement from '~pages/legal/service-agreement';
import defaultHydrate from '~server/hydrate/common';
import notFoundHydrate from '~server/hydrate/not-found';
import unrecognisedEmailActivityHydrate from '~server/hydrate/unrecognised-email-activity';
import NotFound from '~pages/not-found';
import EnterpriseQuotePortal from '~pages/enterprise-quote-portal';
import UnrecognisedEmailActivity from '~pages/unrecognised-email-activity';
import SecurityAndComplianceOverview from '~pages/legal/security-and-compliance-overview';
import MSSPs from '~pages/mssps';
const routes = [
    {
        path: '/',
        exact: true,
        component: Home,
        hydrate: defaultHydrate,
        title: '',
        description: 'PhishTool gives human analysts the power to reverse engineer phishing emails, to better defend against them. Try PhishTool Community for free.',
    },
    {
        path: '/mssps',
        exact: true,
        component: MSSPs,
        hydrate: defaultHydrate,
        title: 'MSSPs',
        description: 'Investigate, respond, and report on phishing threats across multiple MSSP clients, all from one central, white-label capable platform. PhishTool Enterprise gives Managed Service Providers the speed, clarity, and control needed to deliver email security as a service at scale.',
    },
    {
        path: '/contact',
        exact: true,
        component: () => _jsx(Redirect, { to: "/#contact" }),
        hydrate: defaultHydrate,
    },
    {
        path: '/enterprise-quote-portal/:token',
        exact: true,
        component: EnterpriseQuotePortal,
        hydrate: defaultHydrate,
        title: 'Enterprise Quote Portal',
        description: '',
    },
    {
        path: '/unrecognised-email-activity/:token',
        exact: true,
        component: UnrecognisedEmailActivity,
        hydrate: unrecognisedEmailActivityHydrate,
        title: 'Unrecognised Email Activity',
        description: '',
    },
    {
        path: '/terms-of-service',
        exact: true,
        component: TermsOfService,
        hydrate: defaultHydrate,
        title: 'Terms of Service',
        description: '',
    },
    {
        path: '/privacy-policy',
        exact: true,
        component: PrivacyPolicy,
        hydrate: defaultHydrate,
        title: 'Privacy Policy',
        description: '',
    },
    {
        path: '/proof-of-value-agreement',
        exact: true,
        component: ProofOfValueAgreement,
        hydrate: defaultHydrate,
        title: 'Proof of Value Agreement',
        description: '',
    },
    {
        path: '/service-agreement',
        exact: true,
        component: ServiceAgreement,
        hydrate: defaultHydrate,
        title: 'Service Agreement',
        description: '',
    },
    {
        path: '/security-and-compliance-overview',
        exact: true,
        component: SecurityAndComplianceOverview,
        hydrate: defaultHydrate,
        title: 'Security and Compliance Overview',
        description: '',
    },
    {
        path: '*',
        component: NotFound,
        hydrate: notFoundHydrate,
    },
];
export default routes;
